<template>
  <AppBody :subtitle="$t('sales.discount-coupon.title')" :actions="actions">
    <MultiStepper
      :data="data"
      :free-navigate="isEdit"
      :elevation="0"
      rounded="xl"
    >
      <template v-slot:content1>
        <CouponInformation ref="couponInformationForm" />
      </template>
      <template v-slot:content2>
        <PricesAndDiscounts ref="pricesAndDiscountsForm" />
      </template>
      <template v-slot:content3>
        <GeneralSettings ref="generalSettingsForm" />
      </template>
    </MultiStepper>
  </AppBody>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AppBody from "../../layouts/components/AppBody.vue";
import MultiStepper from "../../components/MultiStepper.vue";
import CouponInformation from "../../components/vendas/discountCoupon/CouponInformation.vue";
import PricesAndDiscounts from "../../components/vendas/discountCoupon/PricesAndDiscounts.vue";
import GeneralSettings from "../../components/vendas/discountCoupon/GeneralSettings.vue";

export default {
  name: "CupomDescontoSettings",
  metaInfo() {
    const title = this.$t("sales.discount-coupon.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  components: {
    AppBody,
    MultiStepper,
    CouponInformation,
    PricesAndDiscounts,
    GeneralSettings,
  },
  computed: {
    ...mapGetters(["couponData"]),
    actions() {
      return [
        {
          name: this.$t("sales.discount-coupon.go-back"),
          iconLeft: "mdi-keyboard-return",
          action: () => this.$router.push({ name: "discountCoupon" }),
          outlined: "outlined",
        },
      ];
    },
    data() {
      return [
        {
          title: this.$t("sales.discount-coupon.coupon-information"),
          name: "couponInformation",
          disabledPrev: true,
          textPrev: this.$t("sales.discount-coupon.previous"),
          next: () => {
            return this.couponInformation();
          },
        },
        {
          title: this.$t("sales.discount-coupon.prices-and-discounts"),
          name: "pricesAndDiscounts",
          textPrev: this.$t("sales.discount-coupon.previous"),

          next: () => {
            return this.pricesAndDiscounts();
          },
        },
        {
          title: this.$t("sales.discount-coupon.general-settings"),
          name: "generalSettings",
          textNext: this.isEdit
            ? this.$t("sales.discount-coupon.finish-edit")
            : this.$t("sales.discount-coupon.finish-register"),
          textPrev: this.$t("sales.discount-coupon.previous"),
          next: () => {
            return this.generalSettings();
          },
        },
      ];
    },
    isEdit() {
      return this.$route.path == "/cupom-desconto/editar";
    },
  },
  methods: {
    ...mapActions(["handleDiscountCoupon", "showSnackbarError"]),
    ...mapMutations(["setCouponData"]),
    couponInformation() {
      const isValid = this.$refs.couponInformationForm.$refs.form.validate();
      if (!isValid) return;

      return true;
    },
    pricesAndDiscounts() {
      const isValid = this.$refs.pricesAndDiscountsForm.$refs.form.validate();
      if (!isValid) return;

      return true;
    },
    generalSettings() {
      const isValid = this.$refs.generalSettingsForm.$refs.form.validate();
      if (!isValid) return;

      if (
        this.couponData.discountType == "value" &&
        this.couponData.discountValue <= 0
      ) {
        this.showSnackbarError(
          this.$t("sales.discount-coupon.discount-value-error")
        );
        return;
      } else if (
        this.couponData.discountType == "percentage" &&
        this.couponData.discountPercentage <= 0
      ) {
        this.showSnackbarError(
          this.$t("sales.discount-coupon.discount-percentage-error")
        );
      }

      this.handleDiscountCoupon(this.isEdit ? "update" : "register");

      return false;
    },
  },
  destroyed() {
    this.setCouponData({});
  },
};
</script>

<style scoped></style>
